import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { get as getTheme } from 'Components/Base/constants';
import { ButtonFilled, Flex, SvgIcon, Text } from 'Components/Base';

const StyledButtonFilled = styled(ButtonFilled)`
  position: absolute;
  bottom: 20px;
  align-self: center;
  width: fit-content;
  text-align: center;
  cursor: default;
  border: none;
  height: auto;
  border-radius: 300px;
  background-color: rgba(0, 0, 0, 0.8);

  &:hover,
  &:focus,
  &:active {
    background-color: rgba(0, 0, 0, 0.8);
  }

  &:focus-visible {
    outline: none;
  }

  @media (max-width: ${getTheme('breakpoints.2')}) {
    margin-top: 24px;
  }
`;

const ButtonScrollDown = (props) => (
  <StyledButtonFilled {...props}>
    <Flex justifyContent="center" alignItems="center">
      <SvgIcon mr={3} size={24} icon={SvgIcon.ICON_LIST.SCROLL_DOWN} />
      <Text textStyle="body1">{'See more'}</Text>
    </Flex>
  </StyledButtonFilled>
);

ButtonScrollDown.propTypes = {
  showIndicator: PropTypes.bool,
};

export default ButtonScrollDown;
